import { useQuery } from 'react-query';
import { getUserInfo, type UserInfoResponse } from '../../services/userService';

export function useGetUserInfo(options?: { enabled?: boolean }) {
  return useQuery<UserInfoResponse, Error, UserInfoResponse>(['userInfo'], getUserInfo, {
    enabled: options?.enabled ?? true,
    staleTime: 60 * 10 * 1000,
    cacheTime: 60 * 10 * 1000
  });
}
